import { gql } from 'apollo-angular';

export const ValidateURLDocument = gql`
  query validateURL($url: String!) {
    validateURL(url: $url)
  }
`;
